const usePasswordRules = (rules = {}) => {
  const passRules = {
    passLowerCaseReq: true,
    passMinLength: rules.PasswordMinLength,
    passMaxLength: rules.PasswordMaxLength,
    passNumericsReq: rules.NoOfNumericsReqd,
    passUpperCaseReq: rules.NoOfUpperCaseReqd,
    passSpecialCharReq: rules.NoOfSpecialCharactersReqd,
  };

  const isMinLength = (str, len) => {
    if (str && str?.length >= len) return true;

    return false;
  };

  const oneUpperCase = (str) => {
    const regex = new RegExp(/^((?=.*[A-Z]){1}).*$/);
    return regex.test(str);
  };

  //const oneLowerCase = ( str ) => {
  //const regex = new RegExp( /^((?=.*[a-z]){1}).*$/ );
  //return regex.test( str );
  //};

  const oneNumber = (str) => {
    const regex = new RegExp(/^(?=.*[0-9]).*$/);
    return regex.test(str);
  };

  const oneSymbol = (str) => {
    const regex = new RegExp(
      /^((?=.*[-!$%^&*()/_\\+|~='"\]`{}:[;<>?,.@#]){1}).*$/,
    );
    return regex.test(str);
  };

  return {
    passRules,
    isMinLength,
    oneUpperCase,
    oneNumber,
    oneSymbol,
  };
};

export default usePasswordRules;
